<script setup lang="ts">
defineProps<{
  title: string
  size?: 'xl' | '2xl' | '4xl'
  alignment?: 'left' | 'center'
  showLogoMark?: boolean
  backgroundColor?: 'white' | 'primary' | 'secondary' | 'muted' | 'transparent'
}>()
</script>

<template>
  <ContentBlockViewPartialContainer
    :background-color="backgroundColor"

    class="pt-4"
  >
    <div
      class="flex flex-col items-start gap-y-0"
      :class="{
        'items-center': alignment === 'center'
      }"
    >
      <PublicLogoMark
        v-if="showLogoMark"
        class="w-16"
      />

      <BaseHeading
        as="h2"
        :size="size"
        class="text-theme-content"
        :class="{
          'text-left': alignment === 'left',
          'text-center': alignment === 'center'
        }"
      >
        {{ title }}
      </BaseHeading>
    </div>
  </ContentBlockViewPartialContainer>
</template>
